// 구분(로봇 이슈 / 로봇 외 이슈) 칸 · 고르기 — 고장 조치 이력과 고객사 리포트가 같이 쓴다(2026-10-28 오너 "구분 칸").

import type { CSSProperties } from 'react';
import { IssueCategory, ISSUE_CATEGORY_LABELS } from '@bhops/shared';

const control: CSSProperties = {
  padding: '6px 8px',
  borderRadius: 'var(--r-input)',
  border: '1px solid var(--border-default)',
  fontSize: 13,
  background: 'var(--bg-surface)',
  color: 'var(--fg-default)',
};

/**
 * 구분 — 로봇 이슈 / 로봇 외 이슈(2026-10-27). 사람이 안 정한 줄은 키워드 자동 분류라 '자동'을 작게 붙인다.
 */
export function CategoryCell({
  category,
  auto,
  autoHint = '증상 · 조치 글',
}: {
  category: IssueCategory;
  auto: boolean;
  autoHint?: string;
}) {
  const robot = category === IssueCategory.ROBOT;
  return (
    <span
      style={{ display: 'inline-flex', flexDirection: 'column', lineHeight: 1.3 }}
      title={
        auto ? `${autoHint}의 키워드로 자동 분류했습니다. 연필로 고칠 수 있습니다.` : undefined
      }
    >
      <span style={{ fontWeight: 600, color: robot ? 'var(--fg-default)' : 'var(--dday-warning)' }}>
        {ISSUE_CATEGORY_LABELS[category]}
      </span>
      {auto && <span style={{ fontSize: 11, color: 'var(--text-secondary)' }}>자동</span>}
    </span>
  );
}

/** 구분 고르기 — 비우면(자동) 키워드 분류. 자동일 때 지금 무엇으로 분류되는지 보여 준다. */
export function CategorySelect({
  value,
  onChange,
  autoValue,
  autoHint = '증상 · 조치 글',
  testId = 'remediation-category',
}: {
  value: IssueCategory | '';
  onChange: (v: IssueCategory | '') => void;
  autoValue?: IssueCategory;
  /** 자동 분류가 읽는 글 — 화면마다 다르다(조치 이력은 증상 · 조치, 고객사 리포트는 요약). */
  autoHint?: string;
  testId?: string;
}) {
  return (
    <label style={{ fontSize: 12, fontWeight: 600 }}>
      구분
      <select
        style={{ ...control, width: '100%', marginTop: 4 }}
        value={value}
        onChange={(e) => onChange(e.target.value as IssueCategory | '')}
        aria-label="구분"
        data-testid={testId}
        title={`비워 두면 ${autoHint}의 키워드로 자동 분류합니다.`}
      >
        <option value="">
          자동 (키워드){autoValue ? ` — 지금 ${ISSUE_CATEGORY_LABELS[autoValue]}` : ''}
        </option>
        <option value={IssueCategory.ROBOT}>{ISSUE_CATEGORY_LABELS.ROBOT}</option>
        <option value={IssueCategory.NON_ROBOT}>{ISSUE_CATEGORY_LABELS.NON_ROBOT}</option>
      </select>
    </label>
  );
}
